import { useQuery } from "@tanstack/react-query";
import { dashApi } from "@/lib/dashApi";
import { useFilters } from "@/lib/filters";
import { fmtRelative } from "@/lib/format";
import { num, rows } from "@/lib/kpi";
import {
  BarList,
  ErrorState,
  GapList,
  KpiCard,
  LoadingState,
  PageHeader,
  Panel,
  StatusPill,
} from "@/components/dash/ui";

type BranchCoverage = { name: string; code: string; shifts: number };

export default function RotaPage() {
  const { range } = useFilters();
  const q = useQuery({ queryKey: ["src", "rota", range], queryFn: () => dashApi.source("rota", range) });
  const k = q.data?.kpis;

  return (
    <div className="space-y-6">
      <PageHeader
        title="Rota / Staff"
        description="IronRota scheduling, attendance and coverage."
        right={q.data && <span className="flex items-center gap-2"><StatusPill status={q.data.status} /><span className="text-xs text-slate-500">{fmtRelative(q.data.captured_at)}</span></span>}
      />
      {q.isLoading ? <LoadingState /> : q.isError ? <ErrorState error={q.error} /> : (
        <>
          <div className="grid grid-cols-2 gap-4 md:grid-cols-4 xl:grid-cols-8">
            <KpiCard label="Shifts published" value={num(k, "shifts_published")} unit="count" />
            <KpiCard label="Staff scheduled" value={num(k, "staff_scheduled")} unit="count" />
            <KpiCard label="Active staff" value={num(k, "active_staff")} unit="count" />
            <KpiCard label="Attendance recs" value={num(k, "attendance_records")} unit="count" />
            <KpiCard label="Open clock-ins" value={num(k, "open_clockins")} unit="count" />
            <KpiCard label="Late clock-ins" value={num(k, "late_clockins")} unit="count" tone="danger" />
            <KpiCard label="Missed shifts" value={num(k, "missed_shifts")} unit="count" tone="danger" />
            <KpiCard label="Leave pending" value={num(k, "leave_pending")} unit="count" />
          </div>
          <Panel title="Branch coverage (published shifts)">
            <BarList
              rows={rows<BranchCoverage>(k, "branch_coverage").map((r) => ({ label: r.name, value: r.shifts }))}
              unit="count"
            />
          </Panel>
          {q.data && <GapList gaps={q.data.gaps} />}
        </>
      )}
    </div>
  );
}
